import React from "react";
import {withNamespaces} from "react-i18next";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {connect} from "react-redux";
import {Button, Dropdown} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import {claimTypes} from "../../../../constants/claim.constants";

const NetworkDeviceActionPowerOnOffButtons = (
    {
        row,
        t,
        size,
        claimButton,
        shutDownPc,
        powerOnPc,
        showModal,
        hideModal,
        dropdownItem = false,
    }) => {

    const openModalPowerOff = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('shutdown-pc-msg') + ' ' + model.label,
            confirmLabel: t('shutdown-btn'),
            confirmIcon: 'fa-power-off',
            classNameBtnConfirm: 'btn-danger',
            dataId: model.id,
            confirmAction: (id) => {
                shutDownPc(id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const openModalPowerOn = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('power-on-msg') + ' ' + model.label + " " + t('power-on-msg-description'),
            confirmLabel: t('power-on-btn'),
            confirmIcon: 'fa-power-off',
            classNameBtnConfirm: 'btn-primary',
            dataId: model.id,
            confirmAction: (id) => {
                powerOnPc(id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const closeModal = () => {
        hideModal()
    };


    return (
        claimButton === claimTypes.READ_WRITE ? (

            dropdownItem ? (
                <>
                    <Dropdown.Item onClick={() => openModalPowerOn(row)}><i className="fas fa-power-off"> </i> &nbsp; ON</Dropdown.Item>
                    <Dropdown.Item onClick={() => openModalPowerOff(row)}><i className="fas fa-power-off"> </i> &nbsp; OFF</Dropdown.Item>
                </>
            ) : (
                <>
                    <Button variant={"outline-success"} size={size} className="mx-1" onClick={() => openModalPowerOn(row)}>
                        <i className="fas fa-power-off"> </i> ON
                    </Button>
                    
                    <Button variant={"danger"} size={size} className="mx-1" onClick={() => openModalPowerOff(row)}>
                        <i className="fas fa-power-off"> </i> OFF
                    </Button>
                </>
            )
        ) : (
            <React.Fragment/>
        )
    )

}
const mapDispatchToProps = dispatch => ({
    shutDownPc: (id) => dispatch(networkDeviceActions.shutDownPc(id)),
    powerOnPc: (id) => dispatch(networkDeviceActions.powerOnPc(id)),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    },
    hideModal: () => dispatch(modalActions.hideModal())
})
export default withNamespaces()(connect(null, mapDispatchToProps)(NetworkDeviceActionPowerOnOffButtons));
